import { useRef } from 'react';

export const useDocumentSettings = (metadata = {}) => {
  const ref = useRef(null);
  // These calculations assume box-sizing: border-box.
  const height = ref.current ? ref.current.offsetHeight : null;
  const width = ref.current ? ref.current.offsetWidth : null;
  const computedStyle = ref.current ? window.getComputedStyle(ref.current, null) : null;
  const innerHeight = computedStyle ?
    height - (parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom)) :
    null;
  const innerWidth = computedStyle ?
    width - (parseFloat(computedStyle.paddingRight) + parseFloat(computedStyle.paddingLeft)) :
    null;

  return {
    ref,
    documentSettings: {
      height,
      width,
      innerHeight,
      innerWidth,
      ...metadata,
    },
  };
};
